import IActivity from '../../../../interfaces/IActivity';
import { ButtonGroup } from 'react-bootstrap';
import ModalButton from '../../../ModalButton';
import ActivityEntry from '../Components/ActivityEntry';
import React from 'react';

const ActivityActions: React.FC<{
    index: number;
    activity: IActivity;
    editableActivity: IActivity;
    handleUpdateActivity: (index: number) => void;
    handleDeleteActivity: (index: number) => void;
    handleEditableActivityUpdate: (name: string, value: any) => void;
    generateNewActivityTemplate: () => IActivity;
    setEditableActivity: React.Dispatch<React.SetStateAction<IActivity>>;
    isValid: (activity: IActivity) => boolean;
}> = ({
    index,
    activity,
    editableActivity,
    handleUpdateActivity,
    handleDeleteActivity,
    handleEditableActivityUpdate,
    generateNewActivityTemplate,
    setEditableActivity,
    isValid,
}) => (
    <ButtonGroup>
        <ModalButton
            buttonText={''}
            modalProps={{ size: 'lg' }}
            confirmBtnText={'Update activity'}
            onConfirmModalBtn={() => handleUpdateActivity(index)}
            onCancelModalBtn={() => setEditableActivity(generateNewActivityTemplate())}
            beforeShow={() => {
                setEditableActivity(activity);
            }}
            modalTitle={'Edit activity'}
            buttonProps={{
                as: 'i',
                className:
                    'btn-sm btn-secondary border-0 text-secondary bi bi-pencil bg-transparent fs-5',
                title: 'Edit activity ' + activity.eventAndTitle,
            }}
            cancelButtonProps={{
                variant: 'outline-secondary',
                className: 'text-primary fs-6',
            }}
            confirmButtonProps={{
                className: 'text-primary fs-6',
                disabled: !isValid(editableActivity),
            }}
        >
            <ActivityEntry
                index={index}
                activity={editableActivity}
                handleInputChange={(name, value) => handleEditableActivityUpdate(name, value)}
            />
        </ModalButton>
        <ModalButton
            buttonText={''}
            confirmBtnText="Confirm: delete"
            onConfirmModalBtn={() => handleDeleteActivity(index)}
            buttonProps={{
                as: 'i',
                className: 'btn-sm text-danger border-0 bi bi-trash bg-transparent fs-5',
                title: 'Delete activity ' + activity.eventAndTitle,
            }}
            modalTitle="Are you sure you want to delete this record?"
            confirmButtonProps={{
                variant: 'outline-danger',
            }}
            cancelButtonProps={{
                variant: 'outline-secondary',
            }}
            cancelBtnText="Cancel: keep record"
        >
            This can't be undone.
        </ModalButton>
    </ButtonGroup>
);

export default ActivityActions;
